<script>

const apiSrc = "https://enjoykaohsiung.thinker.tw";
const subDirectory = "/Platform";

//const apiSrc = "https://men-go.tw";
//const subDirectory = "/Platform";

//const apiSrc = "https://localhost:44320";
//const subDirectory = "";

const QRCId = 31;
// 正式站上版後改為 https://ibusplus.tbkc.gov.tw
const tripPlanningHost = "https://qa-citygpt.foxconn.com";
const localVer = "20260921.01.DEBUG";
export default {
  apiSrc,
  subDirectory,
  localVer,
  QRCId,
  tripPlanningHost
};
</script>



// WEBPACK FOOTER //
// src/components/Global.vue